import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=4ac09370&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=4ac09370&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac09370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac09370')) {
      api.createRecord('4ac09370', component.options)
    } else {
      api.reload('4ac09370', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=4ac09370&scoped=true&", function () {
      api.rerender('4ac09370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yOJNBFr2rFxh/JS/comp/Paginate.vue"
export default component.exports